"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBucketPercent = exports.getRandomNumber = void 0;
const seedrandom = require("seedrandom");
const context_1 = require("./context");
const murmurhash_1 = require("./murmurhash");
function getRandomNumber(seed) {
    const rng = seedrandom(seed);
    return rng();
}
exports.getRandomNumber = getRandomNumber;
function getBucketPercent(bucketValue, context) {
    const bucketingInput = `${bucketValue}${context.getDynamicValueName()}`;
    let output;
    switch (context.bucketingMethod) {
        case context_1.BucketingMethod.Universal:
            output = murmurhash_1.bucket(bucketingInput);
            context.addResolutionLog(`Universal bucketing. Hashed '${bucketingInput}' to: ${output}`);
            return output;
        case context_1.BucketingMethod.Legacy:
        default:
            output = getRandomNumber(bucketingInput) * 100;
            context.addResolutionLog(`Legacy bucketing. Mapped '${bucketingInput}' to: ${output}`);
            return output;
    }
}
exports.getBucketPercent = getBucketPercent;
//# sourceMappingURL=rng.js.map